import { render, staticRenderFns } from "./ThirdAssignmentPage.vue?vue&type=template&id=4e59551d&scoped=true&"
import script from "./ThirdAssignmentPage.vue?vue&type=script&lang=js&"
export * from "./ThirdAssignmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e59551d",
  null
  
)

export default component.exports